const css = `@charset "UTF-8";
.coupones-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.coupons-header-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
@media (max-width: 576px) {
  .coupons-header-options {
    gap: 8px;
    /* Ajustar botones para dispositivos móviles */
  }
  .coupons-header-options > button,
  .coupons-header-options > div {
    margin-bottom: 8px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL0NvdXBvbnMiLCJzb3VyY2VzIjpbIkNvdXBvbnMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQU5GO0lBT0k7QUFFQTs7RUFDQTtBQUFBO0lBRUUiLCJzb3VyY2VzQ29udGVudCI6WyIuY291cG9uZXMtcGFnZSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMTZweDtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4uY291cG9ucy1oZWFkZXItb3B0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgZ2FwOiAxNnB4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIEBtZWRpYSAobWF4LXdpZHRoOiA1NzZweCkge1xuICAgIGdhcDogOHB4O1xuXG4gICAgLyogQWp1c3RhciBib3RvbmVzIHBhcmEgZGlzcG9zaXRpdm9zIG3Ds3ZpbGVzICovXG4gICAgPiBidXR0b24sXG4gICAgPiBkaXYge1xuICAgICAgbWFyZ2luLWJvdHRvbTogOHB4O1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
